export default "__VITE_ASSET__BcKHhtdu__"